.
<template>
  <div class="main">
    <el-table
      :data="goodsData"
      show-summary
      :summary-method="getSummaries"
      border
      :header-row-style="{'font-weight': 100, 'color': '#0D0202'}"
      :row-style="{'font-size': '14px', 'color': '#0D0202'}"
      :header-cell-style="{'font-weight': 'bold', 'background': '#F0F2F8'}"
    >
      <el-table-column
        prop="goodsId"
        label="商品ID"
        width="100"
        fixed
      >
        <el-table-column
          prop="goodsId"
          label="总计"
          width="100"
        />
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        width="120"
        fixed
      >
        <el-table-column
          prop="goodsName"
          width="120"
        />
      </el-table-column>
      <el-table-column
        prop="skuName"
        label="商品规格"
        width="120"
        fixed
      >
        <el-table-column
          prop="skuName"
          width="120"
        />
      </el-table-column>
      <el-table-column
        prop="purchaseCount"
        label="订货数"
      >
        <el-table-column
          prop="purchaseCount"
          :label="$route.query.purchaseCount"
        />
      </el-table-column>
      <el-table-column
        prop="purchaseAmount"
        label="订货金额（元）"
        width="150"
      >
        <el-table-column
          prop="purchaseAmount"
          width="150"
          :label="$route.query.purchaseAmount"
        />
      </el-table-column>
      <el-table-column
        prop="refundCount"
        width="150"
        label="订货退货数"
      >
        <el-table-column
          width="150"
          prop="refundCount"
          :label="$route.query.refundCount"
        />
      </el-table-column>
      <el-table-column
        prop="refundAmount"
        label="订货退货金额（元）"
        width="150"
      >
        <el-table-column
          prop="refundAmount"
          width="150"
          :label="$route.query.refundAmount"
        />
      </el-table-column>
      <el-table-column
        prop="actuallyCount"
        label="实际订货数"
        width="100"
      >
        <el-table-column
          prop="actuallyCount"
          width="100"
          :label="$route.query.actuallyCount"
        />
      </el-table-column>
      <el-table-column
        prop="actuallyAmount"
        label="实际订货金额（元）"
        width="150"
      >
        <el-table-column
          prop="actuallyAmount"
          width="150"
          :label="$route.query.actuallyAmount"
        />
      </el-table-column>
      <el-table-column
        prop="checkCount"
        label="订货对账数"
        width="100"
      >
        <el-table-column
          prop="checkCount"
          width="100"
          :label="$route.query.checkCount"
        />
      </el-table-column>
      <el-table-column
        prop="checkAmount"
        label="订货对账金额（元）"
        width="150"
      >
        <el-table-column
          prop="checkAmount"
          width="150"
          :label="$route.query.checkAmount"
        />
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script setup>
import {
  ref, onMounted, getCurrentInstance, computed,
} from 'vue';
// import dayjs from 'dayjs';

const app = getCurrentInstance().proxy;
const { $route } = app;
const goodsData = ref([]); // 明细信息
const currentPage = ref(1); // 分页
const pageSize = ref(10);
const count = ref(0);
const loading = ref(false);
// 计算属性简写方式(计算属性不可被修改)
const orderId = computed(() => {
  return $route.query.supplySettlementId;
});

const getDetail = async () => {
  loading.value = true;
  const res = await app.$axios.post(app.$api.supplierSettlement.goods, {
    currentPage: currentPage.value,
    pageSize: pageSize.value,
    supplySettlementId: orderId.value, // 结算单id
  });
  goodsData.value = res.data.records;
  count.value = Number(res.data.total);
  loading.value = false;
};

const handleSizeChange = (val) => {
  pageSize.value = val;
  currentPage.value = 1;
  getDetail();
};

const handleCurrentChange = (val) => {
  currentPage.value = val;
  getDetail();
};
const getSummaries = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '当前页小计';
      return;
    }
    // 总的展示字段
    let dataKey = [
      'purchaseCount',
      'purchaseAmount',
      'refundCount',
      'refundAmount',
      'actuallyCount',
      'actuallyAmount',
      'checkCount',
      'checkAmount',
    ];
    // 不需要保留两位小数的字段
    let noDecimal = ['purchaseCount', 'refundCount', 'actuallyCount', 'checkCount'];
    if (dataKey.includes(column.property)) {
      const values = data.map((item) => Number(item[column.property]));
      if (!values.every((value) => Number.isNaN(value))) {
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!Number.isNaN(value)) {
            // let parsedNumber = parseFloat(prev + curr);
            return prev + curr;
          }
          return prev;
        }, 0);
        // 转换保留两个小数
        if (!noDecimal.includes(column.property)) {
          sums[index] = sums[index].toFixed(2);
        }
        sums[index] += '';
      } else {
        sums[index] = '-';
      }
    }
  });

  return sums;
};

onMounted(() => {
  getDetail();
});
</script>

<style lang="scss" scoped>
.main {
  background: #fff;
  padding: 20px;
  .back {
    margin-top: 20px;
  }
  .table-card{
    // :deep(.el-tabs__item){
    //   font-size: 18px;
    // }
  }
  :deep(.el-table__body-wrapper){
    z-index: 1;
  }
}
.header {
  border-left: 3px solid #409EFF;
  padding: 12px;
  font-size: 18px;
  margin: 20px 0;
  .tip {
    font-size: 12px;
    color: #999
  }
  .title {
    display: inline-block;
    margin-right: 50px;
  }
}
.detail-form {
  margin-top: 10px;
  width: 100%;
  font-size: 14px;
  margin-bottom: 10px;
  td {
    padding: 12px 16px;
  }
}
.countdownWrap{
  position:relative;
}
.countdown{
  color:red;
  position:absolute;
  top:12px;
  white-space: nowrap;
}
.order-tips {
  font-size: 14px;
  border: 1px solid #ebeef5;
  padding: 20px;
  text-align: center;
}
.goods{
  display: flex;
  img {
    width: 70px;
    height: 70px;
  }
  p {
    padding: 0 12px;
  }
  .id {
    color: #736E6E;
  }
}
.remark {
  padding: 12px 8px;
  border: 1px solid #dfe6ec;
  margin-bottom: 10px;
}
</style>
